module.exports = __webpack_public_path__ + "img/Dingtalk_20240124164945.29f3306e.jpg";